import * as _nodeFetch2 from "node-fetch";
var _nodeFetch = _nodeFetch2;
try {
  if ("default" in _nodeFetch2) _nodeFetch = _nodeFetch2.default;
} catch (e) {}
import * as _http2 from "http";
var _http = _http2;
try {
  if ("default" in _http2) _http = _http2.default;
} catch (e) {}
import * as _https2 from "https";
var _https = _https2;
try {
  if ("default" in _https2) _https = _https2.default;
} catch (e) {}
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const node_fetch_1 = __importDefault(_nodeFetch);
const http_1 = __importDefault(_http);
const https_1 = __importDefault(_https);
const httpAgent = new http_1.default.Agent({
  keepAlive: true
});
const httpsAgent = new https_1.default.Agent({
  keepAlive: true
});
function agent(_parsedURL) {
  if (_parsedURL.protocol === "http:") {
    return httpAgent;
  } else {
    return httpsAgent;
  }
}
function default_1(resource, init) {
  return (0, node_fetch_1.default)(resource, Object.assign({
    agent: agent(new URL(resource.toString()))
  }, init));
}
exports.default = default_1;
export default exports;